import { INIT, INIT_SUCCESS, INIT_FAILED, CANCEL_DONATION_SCHEDULE } from './constants';

export const initAction = (id: string) => ({ type: INIT, id });
export const initSuccessAction = () => ({ type: INIT_SUCCESS });
export const initFailedAction = (error: Error) => ({
  type: INIT_FAILED,
  error,
});
export const cancelDonationScheduleAction = (id: string) => ({
  type: CANCEL_DONATION_SCHEDULE,
  id,
});
